import zh from './zh.yaml'
import en from './en.yaml'

export default { zh, en }
